<style lang="scss" src="./main.scss" />

<template>
    <div id="progress-bar" class="progress-bar">
        <div class="progress-bar-value"></div>
    </div>
    <router-view />
</template>
